<template>
  <iColumn :width="300" gap="none" class="feed-sidebar">
    <iRow
      v-if="orgData.waitlist_status === waitlistStatus.creatorApproved"
      wrap="nowrap"
      vertical-align="middle"
      gap="extraSmall"
      :class="['feed', {selected: currentPath === `/${orgId}/creator`}]"
    >
      <iLink :href="`/${orgId}/creator`" class="home-feed-link">
        <iRow wrap="nowrap" vertical-align="middle" gap="extraSmall">
          <iIcon name="material-symbols:dashboard-outline" />
          <iText>Dashboard</iText>
        </iRow>
      </iLink>
    </iRow>
    <iRow
      wrap="nowrap"
      vertical-align="middle"
      gap="extraSmall"
      :class="['feed', {selected: currentPath === '/'}]"
    >
      <iLink href="/" class="home-feed-link">
        <iRow wrap="nowrap" vertical-align="middle" gap="extraSmall">
          <iIcon name="material-symbols:home-outline-rounded" />
          <iText>My Feed</iText>
        </iRow>
      </iLink>
    </iRow>
    <template v-for="feed in feeds" :key="feed.feed_id">
      <iRow
        wrap="nowrap"
        :class="['feed', 'cursor-pointer', {selected: currentPath === `/feed/${feed.feed_id}`}]"
        gap="extraSmall"
        vertical-align="middle"
      >
        <iLink :href="`/feed/${feed.feed_id}`">
          <iRow
            wrap="nowrap"
            gap="extraSmall"
            vertical-align="middle"
          >
            <iIcon
              :icon="feed.expanded ? 'caret-down': 'caret-right'"
              @click.stop.prevent="feed.expanded = !feed.expanded"
            />
            <iIcon
              name="material-symbols:folder-outline-rounded"
            />
            <iText :wrap="false">
              {{ feed.name }}
            </iText>
          </iRow>
        </iLink>
      </iRow>
      <iColumn v-show="feed.expanded" gap="none" class="feed-source-container">
        <iRow
          v-for="source in feed.sources.items"
          :key="source.feed_source_id"
          :class="['feed-source', {selected: currentPath === `/feed/source/${source.feed_source_id}`}]"
          vertical-align="middle"
          gap="extraSmall"
        >
          <iLink :href="`/feed/source/${source.feed_source_id}`">
            <iRow
              wrap="nowrap"
              vertical-align="middle"
              gap="extraSmall"
            >
              <iIcon name="material-symbols:news-outline-rounded" />
              <iText>{{ source.entity_name }}</iText>
            </iRow>
          </iLink>
        </iRow>
        <iRow v-if="loadingFeedSources[feed.feed_id]" align="center">
          <iLoadingSpinner size="small" />
        </iRow>
        <iRow v-else-if="feed.sources.has_more" class="load-more-feed-sources-container" width="hug">
          <iButton variant="text" @click="loadNextPageOfFeedSources(feed)">
            Load more
          </iButton>
        </iRow>
        <iRow v-if="feed.sources.items.length === 0" class="no-feed-source-placeholder">
          <iText variant="subtle" font-size="small">
            No feed sources
          </iText>
        </iRow>
      </iColumn>
    </template>
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useFeedStore } from "@/stores/feed-store";
import { useGeneralStore } from "%/stores/general-store";
import { waitlistStatus } from "@/enums/waitlist-enum";

export default {
  name: "FeedSideBar",
  data() {
    return {
      waitlistStatus,
    };
  },
  computed: {
    ...mapState(useFeedStore, ["feeds", "loadingFeedSources"]),
    ...mapState(useGeneralStore, ["orgId", "orgData"]),
    currentPath() {
      return window.location.pathname;
    },
  },
  methods: {
    ...mapActions(useFeedStore, ["loadMoreFeedSources"]),
    loadNextPageOfFeedSources(feed) {
      const lastFeedSourceId = feed.sources.items.at(-1).feed_source_id;
      this.loadMoreFeedSources(feed.feed_id, lastFeedSourceId);
    },
  },
  styleGuide: () => ({
    listElementBorderRadius: { "size.borderRadius": "standard" },
    listElementPadding: { "size.spacing": "small" },
    selectedItemBackgroundColor: { "color.background": "notice" },
    hoverBackgroundColor: { "color.background": "light" },
  }),
};
</script>

<style scoped lang="scss">
.home-feed-link {
  margin-left: 24px;

  &:hover {
    margin-left: 24px;
  }
}

.feed-source {
  padding: 0 v-bind("$getStyles.listElementPadding");
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 56px;
  border-radius: v-bind("$getStyles.listElementBorderRadius");

  &:hover {
    background-color: v-bind("$getStyles.hoverBackgroundColor");
  }

  &.selected {
    background-color: v-bind("$getStyles.selectedItemBackgroundColor") !important;
  }
}

.no-feed-source-placeholder {
  margin-left: 56px;
}

.selected {
  background-color: v-bind("$getStyles.selectedItemBackgroundColor") !important;

  &:hover {
    background-color: v-bind("$getStyles.selectedItemBackgroundColor") !important;
  }
}

.feed {
  padding: v-bind("$getStyles.listElementPadding");
  border-radius: v-bind("$getStyles.listElementBorderRadius");

  &:hover {
    background-color: v-bind("$getStyles.hoverBackgroundColor");
  }
}
</style>
